import Footer from "../../components/Footer";
import Appp from "../../adminComponents/Appp";
// import { FaAlignCenter } from "react-icons/fa";
const AdminHome = () => {
   return (
    <>
      <div className="FormCtainer">
        <Appp />
      </div>
      <Footer />
    </>
  );
};

export default AdminHome;
